//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CyAutocomplete',
  props: {
    placeholder: {
      type: String
    },
    url: {
      type: String
    },
    value: {
      type: String
    }
  },
  data () {
    return {
      selectItem: {},
      myValue: this.value
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.myValue = newValue == null ? '' : newValue
    },
    myValue: function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    selectItem: function (newValue, oldValue) {
      this.$emit('on-select-change', newValue)
    }
  },
  methods: {
    onFetchSuggestions: async function (queryString, cb) {
      let that = this
      let res = await that.$axiosWeb.post(that.url, null, {params: {queryString: queryString, loading: false}})
      let list = []
      if (res.meta.success) {
        list = res.data.resultlist
      } else {
        list = null
      }
      cb(list)
    },

    onSelect: function (item) {
      let that = this
      that.myValue = item.showValue
      that.selectItem = item
    },

    onBlur: function (item) {
      let that = this
      if (that.$Utils.IsEmpty(that.myValue)) {
        that.selectItem = {}
      }
    },

    onClear: function (item) {
      let that = this
      that.myValue = ''
      that.selectItem = {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/autocompletes/CyAutocomplete.vue